// Resize/compress image client-side to keep base64 payloads small.
// Returns a JPEG data URL (string).
export async function fileToResizedDataUrl(file, maxDim = 800, quality = 0.82) {
  if (!file) throw new Error("No file");
  if (!file.type.startsWith("image/")) throw new Error("Not an image");

  const bitmap = await createImageBitmap(file);
  let { width, height } = bitmap;
  if (width > maxDim || height > maxDim) {
    if (width >= height) {
      height = Math.round((height * maxDim) / width);
      width = maxDim;
    } else {
      width = Math.round((width * maxDim) / height);
      height = maxDim;
    }
  }
  const canvas = document.createElement("canvas");
  // Square crop centered for consistent director portraits
  const side = Math.min(width, height);
  canvas.width = side;
  canvas.height = side;
  const ctx = canvas.getContext("2d");
  ctx.imageSmoothingEnabled = true;
  ctx.imageSmoothingQuality = "high";
  // Draw centered crop
  const srcSide = Math.min(bitmap.width, bitmap.height);
  const sx = (bitmap.width - srcSide) / 2;
  const sy = (bitmap.height - srcSide) / 2;
  ctx.drawImage(bitmap, sx, sy, srcSide, srcSide, 0, 0, side, side);
  return canvas.toDataURL("image/jpeg", quality);
}
